
import {
    getRegisterDegreeGroupingRepo, postRegisterDegreeGroupingRepo,
} from "../repositories/degreeGrouping/degreeGrouping";
import {
    getDegreeOrderingRepo, postDegreeOrderingRepo
} from "../repositories/degreeGrouping/degreeOrdering";
import { createSlice } from "@reduxjs/toolkit";

const degreeGroupingSlice = createSlice({
    name: "degreeGroupingReducer",
    initialState: {
        degreeGroupLoading: false,
        degreeGrouping: null,
        degreeGroupingError: null,

        postDegreeGroupNameLoading: false,
        postDegreeGroupingNameData: null,
        postDegreeGroupingNameError: null,

        postDegreeGroupLoading: false,
        postDegreeGroupingData: null,
        postDegreeGroupingError: null,

        putDegreeGroupLoading: false,
        putDegreeGroupingData: null,
        putDegreeGroupingError: null,

        deleteDegreeGroupLoading: false,
        deleteDegreeGroupingData: null,
        deleteDegreeGroupingError: null,

        degreeOrderingLoading: false,
        degreeOrdering: null,
        degreeOrderingError: null,

        degreeOrderingDomainLoading: false,
        degreeOrderingDomain: null,
        degreeOrderingDomainError: null,

        postDegreeOrderingLoading: false,
        postDegreeOrderingData: null,
        postDegreeOrderingError: null,
        
    },
    reducers: {
        getDegreeGroupLoading(state, action) {
            return {
                ...state,
                degreeGroupLoading: true,
            };
        },
        getDegreeGroupingSuccess(state, action) {
            return {
                ...state,
                degreeGroupLoading: false,
                degreeGrouping: action.payload,
            };
        },
        getDegreeGroupingFailure(state, action) {
            return {
                ...state,
                degreeGroupLoading: false,
                degreeGroupingError: action.payload,
            };
        },

        postDegreeGroupNameLoading(state, action) {
            return {
                ...state,
                postDegreeGroupNameLoading: true,
                message:null
            };
        },
        postDegreeGroupingNameSuccess(state, action) {
            return {
                ...state,
                postDegreeGroupNameLoading: false,
                postDegreeGroupingNameData: action.payload,
                message:"Degree Group Name Added Successfully"
            };
        },
        postDegreeGroupingNameFailure(state, action) {
            return {
                ...state,
                postDegreeGroupNameLoading: false,
                postDegreeGroupingNameError: action.payload,
                message: "Failure in Adding Degree Group Name",
            };
        },

        postDegreeGroupLoading(state, action) {
            return {
                ...state,
                postDegreeGroupLoading: true,
                message:null
            };
        },
        postDegreeGroupingSuccess(state, action) {
            return {
                ...state,
                postDegreeGroupLoading: false,
                postDegreeGroupingData: action.payload,
                message:"Degree Group Added Successfully"
            };
        },
        postDegreeGroupingFailure(state, action) {
            return {
                ...state,
                postDegreeGroupLoading: false,
                postDegreeGroupingError: action.payload,
                message: "Failure in Adding Degree Group",
            };
        },

        putDegreeGroupLoading(state, action) {
            return {
                ...state,
                putDegreeGroupLoading: true,
                message:null
            };
        },
        putDegreeGroupingSuccess(state, action) {
            return {
                ...state,
                putDegreeGroupLoading: false,
                putDegreeGroupingData: action.payload,
                message:"Degree Group Saved Successfully"
            };
        },
        putDegreeGroupingFailure(state, action) {
            return {
                ...state,
                putDegreeGroupLoading: false,
                putDegreeGroupingError: action.payload,
                message: "Failure in Saving Degree Group",
            };
        },

        deleteDegreeGroupLoading(state, action) {
            return {
                ...state,
                deleteDegreeGroupLoading: true,
                message:null
            };
        },
        deleteDegreeGroupingSuccess(state, action) {
            return {
                ...state,
                deleteDegreeGroupLoading: false,
                deleteDegreeGroupingData: action.payload,
                message:"Degree Group Deleted Successfully"
            };
        },
        deleteDegreeGroupingFailure(state, action) {
            return {
                ...state,
                deleteDegreeGroupLoading: false,
                deleteDegreeGroupingError: action.payload,
                message: "Failure in Deleting Degree Group",
            };
        },

        getDegreeOrderingLoading(state, action) {
            return {
                ...state,
                degreeOrderingLoading: true,
            };
        },
        getDegreeOrderingSuccess(state, action) {
            return {
                ...state,
                degreeOrderingLoading: false,
                degreeOrdering: action.payload,
            };
        },
        getDegreeOrderingFailure(state, action) {
            return {
                ...state,
                degreeOrderingLoading: false,
                degreeOrderingError: action.payload,
            };
        },
        getDegreeOrderingDomainLoading(state, action) {
            return {
                ...state,
                degreeOrderingDomainLoading: true,
            };
        },
        getDegreeOrderingDomainSuccess(state, action) {
            return {
                ...state,
                degreeOrderingDomainLoading: false,
                degreeOrderingDomain: action.payload,
            };
        },
        getDegreeOrderingDomainFailure(state, action) {
            return {
                ...state,
                degreeOrderingDomainLoading: false,
                degreeOrderingDomainError: action.payload,
            };
        },

        postDegreeOrderingLoading(state, action) {
            return {
                ...state,
                postDegreeOrderingLoading: true,
                message:null
            };
        },
        postDegreeOrderingSuccess(state, action) {
            return {
                ...state,
                postDegreeOrderingLoading: false,
                postDegreeOrderingData: action.payload,
                message:"Degree Orders Saved Successfully"
            };
        },
        postDegreeOrderingFailure(state, action) {
            return {
                ...state,
                postDegreeOrderingLoading: false,
                postDegreeOrderingError: action.payload,
                message: "Failure in Saving Degree Orders",
            };
        },

        clearMessage(state,action){
            return{
                ...state,
                message:null,
                putDegreeGroupingData:null,
                postDegreeGroupingData:null,
                postDegreeGroupingNameData:null,
                deleteDegreeGroupingData:null,
                putDegreeGroupingError:null,
                postDegreeGroupingError:null,
                postDegreeGroupingNameError:null,
                deleteDegreeGroupingError:null,
                postDegreeOrderingData:null,
                postDegreeOrderingError:null,
            }
        }
    },
});
export const {
    getDegreeGroupLoading,
    getDegreeGroupingSuccess,
    getDegreeGroupingFailure,

    postDegreeGroupLoading,
    postDegreeGroupingSuccess,
    postDegreeGroupingFailure,

    postDegreeGroupNameLoading,
    postDegreeGroupingNameSuccess,
    postDegreeGroupingNameFailure,

    putDegreeGroupLoading,
    putDegreeGroupingSuccess,
    putDegreeGroupingFailure,

    deleteDegreeGroupLoading,
    deleteDegreeGroupingSuccess,
    deleteDegreeGroupingFailure,

    getDegreeOrderingLoading,
    getDegreeOrderingSuccess,
    getDegreeOrderingFailure,

    getDegreeOrderingDomainLoading,
    getDegreeOrderingDomainSuccess,
    getDegreeOrderingDomainFailure,

    postDegreeOrderingLoading,
    postDegreeOrderingSuccess,
    postDegreeOrderingFailure,

    clearMessage

} = degreeGroupingSlice.actions;

  export default degreeGroupingSlice.reducer;
